import { INTRO_SCREEN, QUIZ_SCREEN, RESULTS_SCREEN } from 'constants/screens';

import React, { useContext } from 'react';

import { Screen } from '@coursera/components';
import { PluginContainer } from '@coursera/templates';

import { AppContext } from '../store';

import { CardContainer, IntroContainer, ResultsContainer } from './index';

// global styles
import '@coursera/components/theme/global.scss';

function AppContainer() {
  const { state } = useContext(AppContext);

  return (
    <PluginContainer
      pluginTitle="Recruiting for user research"
      pluginSubtitle="Flashcard exercise"
      progress={state.progress}
      showProgress={state.screen === QUIZ_SCREEN}
    >
      <Screen component={IntroContainer} show={state.screen === INTRO_SCREEN} />
      <Screen component={CardContainer} show={state.screen === QUIZ_SCREEN} />
      <Screen component={ResultsContainer} show={state.screen === RESULTS_SCREEN} />
    </PluginContainer>
  );
}

export default AppContainer;
